import { Record } from 'immutable';
const ArticlesQuery = Record({
  hs_archived_in_dashboard: undefined,
  hs_access_rule_type__in: undefined,
  hs_access_rule_ids__in: [],
  hs_group_id: undefined,
  hs_created_by_user_id__eq: undefined,
  hs_knowledge_category_id__in: undefined,
  hs_language__eq: undefined,
  limit: 0,
  hs_name__icontains: undefined,
  offset: 0,
  order: undefined,
  hs_translated_from_id__is_null: '',
  after: undefined,
  hs_published_at__is_null: undefined,
  hs_published_at__gt: undefined
});
export default ArticlesQuery;